import { ISignerData } from '../../../features/completeChart/store/completeChart.types'
import { ConfigurationsConstants } from '../../../features/configurations/store/configurations.constants'
import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { getCurrentDateTimeHH24FormatByTimeZone } from '../../dateTime.util'
import { setValueForPathWithCreate } from '../../object.util'

export const addSignerDateAndExtraSecurityId = (pcr: any): IPcr => {
  try {
    const signerDetails: ISignerData = pcr?.signerDetails
    signerDetails?.forEach((signer) => {
      let dt = ''
      let extraSecurityId = null
      if (signer?.verified) {
        dt = getCurrentDateTimeHH24FormatByTimeZone(ConfigurationsConstants.DEFAULT_TIMEZONE, pcr.createDateTime)
        if (signer?.answer1 && signer?.answer2) {
          extraSecurityId = 1
        }
      }
      setValueForPathWithCreate(signer, 'dt', dt)
      setValueForPathWithCreate(signer, 'extraSecurityId', extraSecurityId)
    })
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addSignerDateAndExtraSecurityId: ${error}`)
    throw error
  }
}
